// extracted by mini-css-extract-plugin
module.exports = {"centered":"style_centered__VcLQL","small":"style_small__3mYFc","medium":"style_medium__bTXby","large":"style_large__PG-GU"};